module.exports = __webpack_public_path__ + "static/img/14.78816ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/zh/14.png
// module id = zKSs
// module chunks = 0